/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Block_Agent_CardInputs */

const cs_builder_block_agent_card = /** @type {(inputs: Builder_Block_Agent_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karta makléře`)
};

const en_builder_block_agent_card = /** @type {(inputs: Builder_Block_Agent_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent contact card`)
};

/**
* | output |
* | --- |
* | "Agent contact card" |
*
* @param {Builder_Block_Agent_CardInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_block_agent_card = /** @type {((inputs?: Builder_Block_Agent_CardInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Block_Agent_CardInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_block_agent_card(inputs)
	return cs_builder_block_agent_card(inputs)
});